module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      isIOS: '40px'
    })
  }, [_c('side-menu', {
    staticClass: "side-menu",
    class: {
      active: _vm.showMenu
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xl:ml-sidebar xl:ml-0"
  }, [_c('navbar'), _vm._v(" "), _c('cart', {
    key: _vm.$store.state.showCart
  }), _vm._v(" "), _c('notifications'), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), _c('portal-target', {
    attrs: {
      "name": "modal"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486c40e6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 637
// module chunks = 66